import type { ReactNode } from "react"
import { TableCell, TableRow } from "@/components/shadcn/table"
import { LoaderGeneral } from "./LoaderGeneral"

interface Props {
  isLoading?: boolean
  isError?: boolean
  /** true = keine Daten vorhanden (null/leere Liste). */
  isEmpty?: boolean
  /** Spaltenzahl der Tabelle — die Zustands-Zeile spannt über alle Spalten. */
  colSpan: number
  loadingMessage?: string
  /** Seitenspezifischer Fehlertext; ohne Angabe Fallback aus `common:table.loadError`. */
  errorMessage?: string
  /** Seitenspezifischer Leer-Text; ohne Angabe Fallback aus `common:table.empty`. */
  emptyMessage?: string
  /** Die Datenzeilen — gezeigt, wenn keiner der Zustände greift. */
  children?: ReactNode
}

/**
 * Lade-/Fehler-/Leer-Zustand für Tabellen. Gehört direkt in ein `<TableBody>` und
 * ersetzt den früher pro DataTable duplizierten `isLoading ? … : isError ? …`-Block.
 * Rendert bei aktivem Zustand eine über alle Spalten gespannte Zeile (`colSpan`), sonst
 * die Datenzeilen (`children`). Text + Spinner kommen aus `LoaderGeneral` (eine Quelle).
 */
export function LoaderTable({
  isLoading,
  isError,
  isEmpty,
  colSpan,
  loadingMessage,
  errorMessage,
  emptyMessage,
  children,
}: Props) {
  if (!isLoading && !isError && !isEmpty) {
    return (<>{children}</>)
  }

  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="text-center">
        <LoaderGeneral
          isLoading={isLoading}
          isError={isError}
          isEmpty={isEmpty}
          loadingMessage={loadingMessage}
          errorMessage={errorMessage}
          emptyMessage={emptyMessage}
        />
      </TableCell>
    </TableRow>
  )
}
